import { Injectable } from '@angular/core'
import { PvsRequestFactoryService } from './pvs-request-factory.service'
import { ApiPath } from '../../config/global-const'
import { SharedService } from './shared.service'

export interface IGiftCardSellNew {
    code: string
    initBalance?: number
    paidInCashAmt?: number
    soldBy?: number
    customerFirstName?: string
    customerLastName?: string
    customerPhoneNumber?: string
    expiredAt?: string
    soldAt?: string
    note?: string
}

@Injectable({
    providedIn: 'root',
})
export class GiftCardService {
    constructor(private requestService: PvsRequestFactoryService, private sharedService: SharedService) {}

    public sellNewCard(
        code: string,
        initBalance: number,
        paidInCashAmt: number,
        soldBy: number,
        customerFirstName: string = null,
        customerLastName: string = null,
        customerPhoneNumber: string = null,
        expiredAt: string = null,
        note: string = null
    ) {
        const url = this.requestService.createUrl(ApiPath.GIFT_CARD.SELL_NEW_CARD.PATH)
        return this.requestService.requestPost(url, {
            code: code,
            initBalance: initBalance,
            paidInCashAmt: paidInCashAmt,
            soldBy: soldBy,
            customerFirstName: customerFirstName,
            customerLastName: customerLastName,
            customerPhoneNumber: customerPhoneNumber,
            expiredAt: expiredAt,
            note: note,
        })
    }

    public getList(params = {}) {
        const p = {
            orderBy: 'id|desc',
            ...params,
        }
        const url = this.requestService.createUrl(ApiPath.GIFT_CARD.PATH)
        return this.requestService.requestGet(url, p)
    }
    public createCode(count: number = 1) {
        const url = this.requestService.createUrl(ApiPath.GIFT_CARD.CREATE_CODE.PATH)
        return this.requestService.requestPost(url, { count: count })
    }

    public checkCode(code: string) {
        const url = this.requestService.createUrl(ApiPath.GIFT_CARD.CHECK_CODE.PATH)
        return this.requestService.requestPost(url, { code: code })
    }
    public checkMultipleBalance(idList: Array<number>, ignoreTurnId: number) {
        const url = this.requestService.createUrl(ApiPath.GIFT_CARD.CHECK_MULTIPLE_BALANCE.PATH)
        return this.requestService.requestPost(url, { idList: idList, ignoreTurnId: ignoreTurnId })
    }
    public revoke(code: string) {
        const url = this.requestService.createUrl(ApiPath.GIFT_CARD.REVOKE.PATH)
        return this.requestService.requestPost(url, { code: code })
    }
}
